(function () {
  let drawerContentSelector = '[data-essential-cart-element="cart-drawer-content"]';
  let checkoutButtonSelector = '[data-essential-cart-element="cart-drawer-checkout-button"]';
  let lineItemActionsSelector = '[data-essential-cart-element="line-item-actions"]';
  let lineItemVariantSelector = '[data-essential-cart-element="line-item-variant-selector"]';
  let componentSelector = '[data-km-essential-cart-content]';
  let dialogSelector = '[data-km-gift-dialog]';
  let giftProductsConfigSelector = '#km-essential-cart-gift-products';
  let initialCartStateSelector = '#km-essential-cart-initial-state';
  let maximumThreshold = 79900;
  let thresholds = [6900, 79900];
  let autoOpenThreshold = 6900;
  let refreshTimer = null;
  let cartRequest = null;
  let refreshQueued = false;
  let lastCart = null;
  let containerSyncTimer = null;
  let containerSyncStopTimer = null;
  let gifts = [];
  let clickListenerInstalled = false;
  let activeGiftIndex = null;
  let selectedGiftStorageKey = 'kmEssentialSelectedGift';
  let selectedGift = null;
  let checkoutBypass = false;
  let checkoutPending = false;
  let checkoutHandoff = false;
  let checkoutHandoffTimer = null;
  let cleanupRequest = null;
  let giftSelectionPending = false;
  let giftRestoreRequest = null;
  let lastGiftRestoreSignature = null;
  let initialCartSync = true;
  let cartSyncRequest = null;
  let cartSyncQueued = false;
  let cartSyncPending = false;
  let pluginCartListenerTimer = null;
  let pluginCartUnsubscribe = null;
  let pluginCartListenerInstalled = false;
  let latestPluginCart = null;
  let giftLineItemSyncTimer = null;
  let giftEntryViewTracked = false;
  let giftAutoOpenState = window.kmEssentialGiftAutoOpenState
    || (window.kmEssentialGiftAutoOpenState = { shown: false });
  let giftAutoOpenStorageKey = 'kmEssentialGiftAutoOpenShown';
  let giftAutoOpenTimer = null;
  let giftDialogOpenedAutomatically = false;
  let giftDialogReminderStorageKey = 'kmEssentialGiftDialogReminderAt';
  let giftEntryLocationStorageKey = 'kmEssentialGiftEntryLocation';
  let giftEntryLocation = 'cart';
  let trackedGiftDetailScrolls = {};
  const whiteListPro = [
    "B0110-06401CL",
    "B0110-15716-CL",
    "B0801-04401CL",
    "B0110-15713-CL",
    "B0110-15737-CL",
    "B0101-01801BK",
    "B0110-06401-SK",
    "B0101-04602-BK",
    "B0802-00319-BK",
    "B0112-02301BK",
    "B0110-12102BK",
    "B0110-15652-CL",
    "B0110-11801CL",
    "B0110-12101BK",
    "B0110-15706-CL",
    "B0110-15721-CL",
    "B0116-00916-BK"
  ]

  function loadGiftProducts() {
    var config = document.querySelector(giftProductsConfigSelector);

    if (!config) {
      return [];
    }

    try {
      return JSON.parse(config.textContent).slice(0, 5).map(function (product, index) {
        var threshold = index < 1 ? thresholds[0] : thresholds[1];
        var images = Array.isArray(product.images) ? product.images.filter(Boolean) : [];

        if (!images.length && product.image) {
          images.push(product.image);
        }

        return {
          threshold: threshold,
          thresholdLabel: formatMoney(threshold),
          title: product.title,
          handle: product.handle,
          description: product.description,
          price: Number(product.price) || 0,
          comparePrice: Number(product.comparePrice) || 0,
          image: product.image,
          images: images,
          url: product.url,
          variants: Array.isArray(product.variants) ? product.variants : []
        };
      });
    } catch (error) {
      return [];
    }
  }

  function loadInitialCartState() {
    var config = document.querySelector(initialCartStateSelector);

    if (!config) {
      return null;
    }

    try {
      var state = JSON.parse(config.textContent);

      var totalPrice = Math.max(0, Number(state.totalPrice) || 0);
      var itemCount = Math.max(0, Number(state.itemCount) || 0);

      return {
        total_price: totalPrice,
        item_count: itemCount,
        has_gift: Boolean(state.hasGift),
        items: itemCount > 0 ? [{ final_line_price: totalPrice, quantity: itemCount }] : []
      };
    } catch (error) {
      return null;
    }
  }

  function escapeHtml(value) {
    var element = document.createElement('span');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function formatMoney(cents) {
    var safeCents = Math.max(0, Math.round(Number(cents) || 0));

    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      var formattedMoney = window.theme.Currency.formatMoney(safeCents, window.theme.settings.moneyFormat);
      var textDecoder = document.createElement('span');
      textDecoder.innerHTML = formattedMoney;
      return textDecoder.textContent;
    }

    return '$' + (safeCents / 100).toFixed(2);
  }

  function getStatus(totalPrice) {
    if (totalPrice < thresholds[0]) {
      return 'Spend ' + formatMoney(thresholds[0] - totalPrice) + ' more to unlock a free gift';
    }

    if (totalPrice < thresholds[1]) {
      return 'Spend ' + formatMoney(thresholds[1] - totalPrice) + ' more to unlock a free gift';
    }

    return "You've unlocked a free gift";
  }

  function buildComponent() {
    var wrapper = document.createElement('section');
    wrapper.setAttribute('data-km-essential-cart-content', '');
    wrapper.className = 'km-cart-gifts';
    wrapper.innerHTML = [
      '<div class="km-cart-gifts__message">',
      '<span class="km-cart-gifts__icon" aria-hidden="true">&#127873;</span>',
      '<strong data-km-gift-message></strong>',
      '<button class="km-cart-gifts__help" type="button" data-km-gift-help aria-label="Free gift terms" aria-expanded="false" aria-controls="km-cart-gifts-help-tooltip" title="Free gift terms">?</button>',
      '<div class="km-cart-gifts__tooltip" id="km-cart-gifts-help-tooltip" data-km-gift-help-tooltip role="tooltip" hidden>',
      '<ol><li>Applies storewide, excluding select products, e.g. select windshields.</li>',
      '<li>One free gift per order, while supplies last; no cash value.</li>',
      '<li>If you return the order, the free gift must also be returned; otherwise, its value will be deducted from your refund.</li></ol>',
      '</div>',
      '</div>',
      '<div class="km-cart-gifts__progress" aria-hidden="true">',
      '<span class="km-cart-gifts__track"></span>',
      '<span class="km-cart-gifts__fill" data-km-gift-progress></span>',
      '<span class="km-cart-gifts__milestone km-cart-gifts__milestone--first" data-km-gift-milestone="69"><i></i><b>$69</b></span>',
      '<span class="km-cart-gifts__milestone km-cart-gifts__milestone--second" data-km-gift-milestone="799"><i></i><b>$799</b></span>',
      '</div>',
      '<div class="km-cart-gifts__selected" data-km-selected-gift hidden aria-hidden="true"></div>',
      '<button class="km-cart-gifts__button" type="button" data-km-gift-open aria-hidden="false">',
      '<span>CHOOSE YOURE GIFT</span><span class="km-cart-gifts__chevron" aria-hidden="true"></span>',
      '</button>',
      '<p class="km-cart-gifts__exclusion-notice" data-km-gift-exclusion-notice hidden aria-hidden="true">Some items don&rsquo;t count toward the free gift threshold.</p>'
    ].join('');
    return wrapper;
  }

  function giftCardMarkup(gift, totalPrice) {
    var unlocked = totalPrice >= gift.threshold;
    var shortfall = Math.max(0, gift.threshold - totalPrice);
    var title = escapeHtml(gift.title);
    var image = gift.image
      ? '<img class="km-gift-card__image" src="' + escapeHtml(gift.image) + '" alt="' + title + '" loading="lazy">'
      : '<div class="km-gift-card__image km-gift-card__image--empty"></div>';
    var status = unlocked
      ? '<span class="km-gift-card__unlocked">Unlocked</span>'
      : '<span class="km-gift-card__locked"><span aria-hidden="true">&#128274;</span> ' + formatMoney(shortfall) + ' more to unlock</span>';

    return [
      '<article class="km-gift-card' + (unlocked ? ' is-unlocked' : ' is-locked') + '">',
      '<div class="km-gift-card__image-wrap">',
      '<span class="km-gift-card__tier">Spend ' + escapeHtml(gift.thresholdLabel) + '</span>',
      image,
      '</div>',
      '<div class="km-gift-card__body">',
      '<h3>' + title + '</h3>',
      '<p class="km-gift-card__price"><strong>Free</strong><s>' + escapeHtml(formatMoney(gift.comparePrice)) + '</s></p>',
      '<p class="km-gift-card__status">' + status + '</p>',
      '<button class="km-gift-card__details" type="button" data-km-gift-detail="' + gifts.indexOf(gift) + '">View details</button>',
      '</div>',
      '</article>'
    ].join('');
  }

  function getDefaultVariant(gift) {
    if (!gift.variants.length) {
      return null;
    }

    return gift.variants.find(function (variant) {
      return variant.available;
    }) || gift.variants[0];
  }

  function findGiftByVariantId(variantId) {
    var stringVariantId = String(variantId || '');

    if (!stringVariantId) {
      return null;
    }

    for (var giftIndex = 0; giftIndex < gifts.length; giftIndex += 1) {
      var gift = gifts[giftIndex];
      var variant = gift.variants.find(function (item) {
        return String(item.id) === stringVariantId;
      });

      if (variant) {
        return {
          gift: gift,
          variant: variant,
          index: giftIndex
        };
      }
    }

    return null;
  }

  function getVariantLabel(variant) {
    if (!variant) {
      return '';
    }

    if (variant.title && variant.title !== 'Default Title') {
      return variant.title;
    }

    return Array.isArray(variant.options) ? variant.options.join(' / ') : variant.title;
  }

  function optionButtonsMarkup(gift, selectedVariant) {
    if (gift.variants.length < 2) {
      return '';
    }

    return [
      '<div class="km-gift-detail__options">',
      '<p>Select option</p>',
      '<div class="km-gift-detail__option-list">',
      gift.variants.map(function (variant) {
        var selected = selectedVariant && String(selectedVariant.id) === String(variant.id);
        return [
          '<button class="km-gift-detail__option' + (selected ? ' is-selected' : '') + '" type="button" data-km-gift-variant="' + escapeHtml(variant.id) + '"' + (variant.available ? '' : ' disabled') + '>',
          escapeHtml(getVariantLabel(variant)),
          '</button>'
        ].join('');
      }).join(''),
      '</div>',
      '</div>'
    ].join('');
  }

  function detailMarkup(gift, index, totalPrice) {
    var unlocked = totalPrice >= gift.threshold;
    var selectedVariant = getDefaultVariant(gift);
    var badge = unlocked ? 'Unlocked' : gift.thresholdLabel + ' tier';
    var actionText = unlocked ? 'Add free gift' : 'Select free gift';
    var description = gift.description
      ? [
        '<div class="km-gift-detail__description">',
        '<h4>Product details</h4>',
        '<div class="km-gift-detail__description-content">' + gift.description + '</div>',
        '</div>'
      ].join('')
      : '';

    return [
      '<div class="km-gift-detail" data-km-gift-detail-view data-km-gift-index="' + index + '" data-selected-variant="' + escapeHtml(selectedVariant ? selectedVariant.id : '') + '">',
      '<div class="km-gift-detail__media">',
      '<span class="km-gift-detail__badge' + (unlocked ? ' is-unlocked' : '') + '">' + escapeHtml(badge) + '</span>',
      giftGalleryMarkup(gift, selectedVariant),
      '</div>',
      '<div class="km-gift-detail__content">',
      '<h3>' + escapeHtml(gift.title) + '</h3>',
      '<p class="km-gift-detail__price"><strong>Free</strong><s>' + escapeHtml(formatMoney(gift.comparePrice || gift.price)) + '</s></p>',
      optionButtonsMarkup(gift, selectedVariant),
      description,
      '</div>',
      '<button class="km-gift-detail__add" type="button" data-km-gift-add' + (selectedVariant && selectedVariant.available ? '' : ' disabled') + '>' + escapeHtml(actionText) + '</button>',
      '</div>'
    ].join('');
  }

  function getGiftGalleryImages(gift) {
    var images = Array.isArray(gift.images) ? gift.images.slice() : [];

    if (!images.length && gift.image) {
      images.push(gift.image);
    }

    gift.variants.forEach(function (variant) {
      if (variant.image && images.indexOf(variant.image) === -1) {
        images.push(variant.image);
      }
    });

    return images.filter(Boolean);
  }

  function giftGalleryMarkup(gift, selectedVariant) {
    var images = getGiftGalleryImages(gift);

    if (!images.length) {
      return '<div class="km-gift-detail__image km-gift-detail__image--empty"></div>';
    }

    var selectedImage = selectedVariant && selectedVariant.image ? selectedVariant.image : gift.image;
    var activeIndex = Math.max(0, images.indexOf(selectedImage));
    var controls = images.length > 1
      ? [
        '<button class="km-gift-gallery__arrow km-gift-gallery__arrow--prev" type="button" data-km-gift-gallery-prev aria-label="Previous product image">&#8249;</button>',
        '<button class="km-gift-gallery__arrow km-gift-gallery__arrow--next" type="button" data-km-gift-gallery-next aria-label="Next product image">&#8250;</button>',
        '<div class="km-gift-gallery__dots">',
        images.map(function (_, imageIndex) {
          return '<button class="km-gift-gallery__dot' + (imageIndex === activeIndex ? ' is-active' : '') + '" type="button" data-km-gift-gallery-index="' + imageIndex + '" aria-label="View product image ' + (imageIndex + 1) + '" aria-current="' + (imageIndex === activeIndex ? 'true' : 'false') + '"></button>';
        }).join(''),
        '</div>'
      ].join('')
      : '';

    return [
      '<div class="km-gift-gallery" data-km-gift-gallery data-active-index="' + activeIndex + '">',
      '<div class="km-gift-gallery__viewport">',
      '<div class="km-gift-gallery__track" data-km-gift-gallery-track style="transform:translate3d(-' + (activeIndex * 100) + '%,0,0)">',
      images.map(function (image, imageIndex) {
        return [
          '<div class="km-gift-gallery__slide" data-km-gift-gallery-slide data-km-gift-gallery-image="' + escapeHtml(image) + '" aria-hidden="' + (imageIndex === activeIndex ? 'false' : 'true') + '">',
          '<img class="km-gift-detail__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(gift.title + (images.length > 1 ? ' - image ' + (imageIndex + 1) : '')) + '">',
          '</div>'
        ].join('');
      }).join(''),
      '</div>',
      controls,
      '</div>',
      '</div>'
    ].join('');
  }

  function setGiftGalleryIndex(gallery, index) {
    var slides = gallery ? gallery.querySelectorAll('[data-km-gift-gallery-slide]') : [];
    var track = gallery ? gallery.querySelector('[data-km-gift-gallery-track]') : null;

    if (!track || !slides.length) {
      return;
    }

    var nextIndex = ((Number(index) || 0) % slides.length + slides.length) % slides.length;
    gallery.setAttribute('data-active-index', nextIndex);
    track.style.transform = 'translate3d(-' + (nextIndex * 100) + '%,0,0)';

    slides.forEach(function (slide, slideIndex) {
      slide.setAttribute('aria-hidden', slideIndex === nextIndex ? 'false' : 'true');
    });

    gallery.querySelectorAll('[data-km-gift-gallery-index]').forEach(function (dot) {
      var isActive = Number(dot.getAttribute('data-km-gift-gallery-index')) === nextIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function moveGiftGallery(gallery, direction) {
    var activeIndex = Number(gallery && gallery.getAttribute('data-active-index')) || 0;
    setGiftGalleryIndex(gallery, activeIndex + direction);
  }

  function showGiftGalleryImage(detail, imageUrl) {
    if (!detail || !imageUrl) {
      return;
    }

    var gallery = detail.querySelector('[data-km-gift-gallery]');
    var slides = gallery ? gallery.querySelectorAll('[data-km-gift-gallery-slide]') : [];

    slides.forEach(function (slide, slideIndex) {
      if (slide.getAttribute('data-km-gift-gallery-image') === imageUrl) {
        setGiftGalleryIndex(gallery, slideIndex);
      }
    });
  }

  function buildDialog() {
    var dialog = document.createElement('div');
    dialog.setAttribute('data-km-gift-dialog', '');
    dialog.className = 'km-gift-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'km-gift-dialog-title');
    dialog.setAttribute('aria-hidden', 'true');
    dialog.hidden = true;
    dialog.innerHTML = [
      '<div class="km-gift-dialog__panel" tabindex="-1">',
      '<header class="km-gift-dialog__header">',
      '<button class="km-gift-dialog__back" type="button" data-km-gift-back hidden aria-hidden="true">Back to gifts</button>',
      '<div><h2 id="km-gift-dialog-title" data-km-gift-dialog-title>CHOOSE YOUR FREE GIFT</h2><p data-km-gift-dialog-subtitle aria-hidden="false" style="color: #e4002b;font-size: 14px;">Pick now, or choose later in cart after adding an item.</p></div>',
      '<button class="km-gift-dialog__close" type="button" data-km-gift-close aria-label="Close gift options">&times;</button>',
      '</header>',
      '<div class="km-gift-dialog__body" data-km-gift-body></div>',
      '<button class="km-gift-dialog__remind-later" type="button" data-km-gift-remind-later hidden aria-hidden="true">Not reminder today</button>',
      '</div>'
    ].join('');

    dialog.addEventListener('click', function (event) {
      var closeButton = event.target.closest('[data-km-gift-close]');

      if (closeButton) {
        trackGiftEvent('click_close_gift_selection_modal', {
          modal_level: activeGiftIndex == null ? 1 : 2
        });
        closeDialog(dialog);
        return;
      }

      if (event.target === dialog) {
        closeDialog(dialog);
        return;
      }

      var gallery = event.target.closest('[data-km-gift-gallery]');
      var galleryDot = event.target.closest('[data-km-gift-gallery-index]');

      if (gallery && galleryDot) {
        event.preventDefault();
        setGiftGalleryIndex(gallery, Number(galleryDot.getAttribute('data-km-gift-gallery-index')));
        return;
      }

      if (gallery && event.target.closest('[data-km-gift-gallery-prev]')) {
        event.preventDefault();
        trackGiftEvent('click_gift_image_navigation', {
          product_id: gifts[activeGiftIndex] ? gifts[activeGiftIndex].handle : ''
        });
        moveGiftGallery(gallery, -1);
        return;
      }

      if (gallery && event.target.closest('[data-km-gift-gallery-next]')) {
        event.preventDefault();
        trackGiftEvent('click_gift_image_navigation', {
          product_id: gifts[activeGiftIndex] ? gifts[activeGiftIndex].handle : ''
        });
        moveGiftGallery(gallery, 1);
        return;
      }

      var detailButton = event.target.closest('[data-km-gift-detail]');
      if (detailButton) {
        var giftIndex = Number(detailButton.getAttribute('data-km-gift-detail'));
        var selectedGiftProduct = gifts[giftIndex];

        event.preventDefault();
        trackGiftEvent('click_gift_details', {
          product_id: selectedGiftProduct ? selectedGiftProduct.handle : ''
        });
        renderGiftDetail(dialog, giftIndex);
        return;
      }

      if (event.target.closest('[data-km-gift-back]')) {
        event.preventDefault();
        trackGiftEvent('click_back_to_gifts');
        renderGiftList(dialog, lastCart);
        return;
      }

      var variantButton = event.target.closest('[data-km-gift-variant]');
      if (variantButton) {
        event.preventDefault();
        selectGiftVariant(dialog, variantButton.getAttribute('data-km-gift-variant'));
        return;
      }

      var addButton = event.target.closest('[data-km-gift-add]');
      if (addButton) {
        var detailView = addButton.closest('[data-km-gift-detail-view]');
        var detailGiftIndex = detailView ? Number(detailView.getAttribute('data-km-gift-index')) : -1;
        var detailGiftProduct = gifts[detailGiftIndex];

        event.preventDefault();
        trackGiftEvent('click_add_free_gift', {
          product_id: detailGiftProduct ? detailGiftProduct.handle : ''
        });
        addSelectedGift(dialog);
        return;
      }

      var remindLaterButton = event.target.closest('[data-km-gift-remind-later]');
      if (remindLaterButton) {
        event.preventDefault();
        suppressGiftDialogReminder();
        closeDialog(dialog);
      }
    });

    dialog.addEventListener('scroll', function (event) {
      var scrollContainer = event.target;
      var detailGiftProduct = gifts[activeGiftIndex];
      var productHandle = detailGiftProduct && detailGiftProduct.handle;
      var isGiftDetailsScroll = activeGiftIndex != null && (
        scrollContainer === dialog
        || (scrollContainer.matches && scrollContainer.matches('.km-gift-detail__content'))
      );

      if (!isGiftDetailsScroll || !productHandle || trackedGiftDetailScrolls[productHandle]) {
        return;
      }

      trackedGiftDetailScrolls[productHandle] = true;
      trackGiftEvent('scroll_gift_details', {
        product_id: productHandle
      });
    }, true);

    var galleryTouchStart = null;

    dialog.addEventListener('touchstart', function (event) {
      var gallery = event.target.closest('[data-km-gift-gallery]');

      if (!gallery || event.touches.length !== 1) {
        galleryTouchStart = null;
        return;
      }

      galleryTouchStart = {
        gallery: gallery,
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }, { passive: true });

    dialog.addEventListener('touchend', function (event) {
      if (!galleryTouchStart || !event.changedTouches.length) {
        galleryTouchStart = null;
        return;
      }

      var deltaX = event.changedTouches[0].clientX - galleryTouchStart.x;
      var deltaY = event.changedTouches[0].clientY - galleryTouchStart.y;

      if (Math.abs(deltaX) >= 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        moveGiftGallery(galleryTouchStart.gallery, deltaX > 0 ? -1 : 1);
      }

      galleryTouchStart = null;
    }, { passive: true });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog(dialog);
      }
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function lockPage() {
    document.documentElement.classList.add('km-gift-dialog-open');
  }

  function unlockPage() {
    document.documentElement.classList.remove('km-gift-dialog-open');
  }

  function openDialog(cart) {
    var dialog = document.querySelector(dialogSelector) || buildDialog();
    var panel = dialog.querySelector('.km-gift-dialog__panel');

    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    dialog.classList.add('is-open');

    lockPage();

    var renderCart = cart || lastCart;

    if (renderCart && activeGiftIndex == null) {
      renderGiftList(dialog, renderCart);
    }

    window.requestAnimationFrame(function () {
      if (!dialog.hidden && panel) {
        panel.focus({ preventScroll: true });
      }
    });

    return dialog;
  }

  function closeDialog(dialog) {
    window.clearTimeout(giftAutoOpenTimer);
    giftAutoOpenTimer = null;

    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    dialog.classList.remove('is-open');
    activeGiftIndex = null;
    giftDialogOpenedAutomatically = false;
    unlockPage();
  }

  function hasGiftDialogAutoOpened() {
    if (giftAutoOpenState.shown) {
      return true;
    }

    try {
      return window.sessionStorage.getItem(giftAutoOpenStorageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function shouldAutoOpenGiftDialog() {
    var cart = arguments.length > 0 ? arguments[0] : lastCart;
    var cartTotal = Number(cart && cart.total_price) || 0;

    if (!cart || hasGiftDialogAutoOpened() || isGiftDialogReminderSuppressed()) {
      return false;
    }

    if (cart.has_gift === true) {
      return false;
    }

    if (getManagedGiftCartItems(cart).length > 0) {
      return false;
    }

    if (isSearchSourceEntry()) {
      return true;
    }

    return Number(cart.item_count) > 0 && cartTotal >= autoOpenThreshold;
  }

  function isSearchSourceEntry() {
    var pathname = window.location.pathname.replace(/\/+$/, '') || '/';
    var searchParams = new URLSearchParams(window.location.search);

    return pathname === '/search' && searchParams.has('source');
  }

  function isGiftDialogReminderSuppressed() {
    var reminderAt;

    try {
      reminderAt = Number(window.localStorage.getItem(giftDialogReminderStorageKey));
    } catch (error) {
      return false;
    }

    if (!Number.isFinite(reminderAt) || reminderAt <= 0) {
      return false;
    }

    if (Date.now() - reminderAt < 24 * 60 * 60 * 1000) {
      return true;
    }

    try {
      window.localStorage.removeItem(giftDialogReminderStorageKey);
    } catch (error) {}

    return false;
  }

  function suppressGiftDialogReminder() {
    try {
      window.localStorage.setItem(giftDialogReminderStorageKey, String(Date.now()));
    } catch (error) {}
  }

  function openGiftDialogAutomatically(cart) {
    if (!shouldAutoOpenGiftDialog(cart)) {
      return false;
    }

    activeGiftIndex = null;
    giftDialogOpenedAutomatically = true;
    var dialog;

    try {
      dialog = openDialog(cart);
    } catch (error) {
      giftDialogOpenedAutomatically = false;
      return false;
    }

    if (!dialog || dialog.hidden) {
      giftDialogOpenedAutomatically = false;
      return false;
    }

    giftAutoOpenState.shown = true;
    try {
      window.sessionStorage.setItem(giftAutoOpenStorageKey, '1');
    } catch (error) {}
    trackGiftEvent('view_gift_selection_modal', { trigger: 'cart_threshold' });
    return true;
  }

  function maybeAutoOpenGiftDialog(cart) {
    if (!shouldAutoOpenGiftDialog(cart)) {
      return false;
    }

    if (giftAutoOpenTimer) {
      return true;
    }

    giftAutoOpenTimer = window.setTimeout(function () {
      giftAutoOpenTimer = null;
      openGiftDialogAutomatically(lastCart || cart);
    }, 700);
    return true;
  }

  function initializeGiftEntryLocation() {
    var source = new URLSearchParams(window.location.search).get('source');
    var normalizedSource = String(source || '').toLowerCase();

    try {
      if (normalizedSource === 'edm') {
        giftEntryLocation = 'edm';
        window.sessionStorage.setItem(giftEntryLocationStorageKey, giftEntryLocation);
        return;
      }

      if (source !== null) {
        giftEntryLocation = 'cart';
        window.sessionStorage.setItem(giftEntryLocationStorageKey, giftEntryLocation);
        return;
      }

      giftEntryLocation = window.sessionStorage.getItem(giftEntryLocationStorageKey) === 'edm'
        ? 'edm'
        : 'cart';
      window.sessionStorage.setItem(giftEntryLocationStorageKey, giftEntryLocation);
    } catch (error) {
      giftEntryLocation = normalizedSource === 'edm' ? 'edm' : 'cart';
    }
  }

  function trackGiftEvent(eventName, params) {
    var payload = Object.assign({}, params || {}, {
      entry_location: giftEntryLocation
    });

    if (typeof window.KMTrackGaEvent === 'function') {
      window.KMTrackGaEvent(eventName, payload);
      return;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function resetCartGiftState() {
    document.querySelectorAll(componentSelector).forEach(function (component) {
      component.remove();
    });

    var dialog = document.querySelector(dialogSelector);
    if (dialog) {
      var body = dialog.querySelector('[data-km-gift-body]');
      if (body) {
        body.innerHTML = '';
      }
      if (!dialog.hidden) {
        closeDialog(dialog);
      }
    }

    unlockPage();
  }

  function setDialogMode(dialog, mode) {
    var title = dialog.querySelector('[data-km-gift-dialog-title]');
    var subtitle = dialog.querySelector('[data-km-gift-dialog-subtitle]');
    var back = dialog.querySelector('[data-km-gift-back]');
    var remindLater = dialog.querySelector('[data-km-gift-remind-later]');

    dialog.classList.toggle('is-detail', mode === 'detail');
    setHiddenState(back, mode !== 'detail');
    setHiddenState(remindLater, mode !== 'list' || !giftDialogOpenedAutomatically);
    title.textContent = mode === 'detail' ? 'Confirm your free gift' : 'Choose your free gift';
    setHiddenState(subtitle, mode === 'detail');
  }

  function renderGiftList(dialog, cart) {
    var totalPrice = getCartTotalWithoutGift(cart);
    var body = dialog.querySelector('[data-km-gift-body]');

    activeGiftIndex = null;
    setDialogMode(dialog, 'list');
    body.innerHTML = gifts.length > 0
      ? '<div class="km-gift-dialog__grid" data-km-gift-grid>' + gifts.map(function (gift) {
        return giftCardMarkup(gift, totalPrice);
      }).join('') + '</div>'
      : '<p class="km-gift-dialog__empty">Gift options are loading.</p>';
  }

  function renderGiftDetail(dialog, index) {
    var gift = gifts[index];
    var body = dialog.querySelector('[data-km-gift-body]');

    if (!gift) {
      return;
    }

    activeGiftIndex = index;
    setDialogMode(dialog, 'detail');
    body.innerHTML = detailMarkup(gift, index, getCartTotalWithoutGift(lastCart));
  }

  function selectGiftVariant(dialog, variantId) {
    var detail = dialog.querySelector('[data-km-gift-detail-view]');
    var gift = activeGiftIndex == null ? null : gifts[activeGiftIndex];

    if (!detail || !gift) {
      return;
    }

    var variant = gift.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (!variant || !variant.available) {
      return;
    }

    detail.setAttribute('data-selected-variant', variant.id);
    detail.querySelectorAll('[data-km-gift-variant]').forEach(function (button) {
      button.classList.toggle('is-selected', String(button.getAttribute('data-km-gift-variant')) === String(variant.id));
    });

    if (variant.image) {
      showGiftGalleryImage(detail, variant.image);
    }
  }

  function addSelectedGift(dialog) {
    var detail = dialog.querySelector('[data-km-gift-detail-view]');
    var addButton = dialog.querySelector('[data-km-gift-add]');
    var variantId = detail && detail.getAttribute('data-selected-variant');

    if (!variantId || !addButton || addButton.disabled) {
      return;
    }

    saveSelectedGift(variantId);
    closeDialog(dialog);
    addSelectedGiftToCart(variantId);
  }

  function addGiftVariantToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          _km_cart_gift: 'true'
        }
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add gift');
        }
        return response.json();
      });
  }

  function refreshEssentialCart() {
    var essentialCartApi = window.essentialCartApi;

    if (!essentialCartApi || typeof essentialCartApi.refreshCart !== 'function') {
      return Promise.resolve();
    }

    return Promise.resolve(essentialCartApi.refreshCart()).catch(function () {});
  }

  function addSelectedGiftToCart(variantId) {
    giftSelectionPending = true;

    return getCart()
      .then(function (cart) {
        var match = findGiftByVariantId(variantId);

        if (!cart || !match || getCartTotalWithoutGift(cart) < match.gift.threshold) {
          return cart;
        }

        if (cartHasGiftVariant(cart, variantId) && getGiftCartItems(cart).length === 1) {
          return cart;
        }

        return removeGiftCartItems(cart, true)
          .then(function () {
            return addGiftVariantToCart(variantId);
          });
      })
      .then(function () {
        return refreshEssentialCart();
      })
      .catch(function () {})
      .finally(function () {
        giftSelectionPending = false;
        scheduleRefresh();
      });
  }

  function restoreSelectedGiftCartItem(cart) {
    var storedSelection = selectedGift || loadSelectedGift();
    var variantId = storedSelection && storedSelection.variantId;
    var match = findGiftByVariantId(variantId);
    var giftItems = getManagedGiftCartItems(cart);
    var cartSignature = getRegularCartSignature(cart);

    if (initialCartSync || giftSelectionPending || checkoutPending || checkoutHandoff || !cart || !match) {
      return Promise.resolve(cart);
    }

    if (getCartTotalWithoutGift(cart) < match.gift.threshold || cartHasGiftVariant(cart, variantId)) {
      return Promise.resolve(cart);
    }

    if (lastGiftRestoreSignature === cartSignature) {
      return Promise.resolve(cart);
    }

    if (giftRestoreRequest) {
      return giftRestoreRequest;
    }

    lastGiftRestoreSignature = cartSignature;
    giftSelectionPending = true;

    var addGift = giftItems.length
      ? removeGiftCartItems(cart, true).then(function () {
        return addGiftVariantToCart(variantId);
      })
      : addGiftVariantToCart(variantId);

    giftRestoreRequest = addGift
      .then(function () {
        return fetchCartSnapshot();
      })
      .finally(function () {
        giftSelectionPending = false;
        giftRestoreRequest = null;
      });

    return giftRestoreRequest;
  }

  function loadSelectedGift() {
    try {
      return JSON.parse(window.localStorage.getItem(selectedGiftStorageKey));
    } catch (error) {
      return null;
    }
  }

  function saveSelectedGift(variantId) {
    var match = findGiftByVariantId(variantId);

    if (!match) {
      return;
    }

    selectedGift = {
      handle: match.gift.handle,
      variantId: String(match.variant.id)
    };
    lastGiftRestoreSignature = null;

    try {
      window.localStorage.setItem(selectedGiftStorageKey, JSON.stringify(selectedGift));
    } catch (error) {}
  }

  function clearSelectedGift() {
    selectedGift = null;
    lastGiftRestoreSignature = null;

    try {
      window.localStorage.removeItem(selectedGiftStorageKey);
    } catch (error) {}
  }

  function resolveSelectedGift(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var storedSelection = selectedGift || loadSelectedGift();
    var selectedVariantId = storedSelection && storedSelection.variantId;
    var cartMatch = null;

    items.some(function (item) {
      var itemVariantId = item && (item.variant_id || item.id);
      var match = findGiftByVariantId(itemVariantId);

      if (match && isGiftCartItem(item) && (!selectedVariantId || String(itemVariantId) === String(selectedVariantId))) {
        cartMatch = match;
        return true;
      }

      return false;
    });

    if (cartMatch) {
      selectedGift = {
        handle: cartMatch.gift.handle,
        variantId: String(cartMatch.variant.id)
      };
      return cartMatch;
    }

    if (selectedVariantId) {
      return findGiftByVariantId(selectedVariantId);
    }

    return null;
  }

  function cartHasGiftVariant(cart, variantId) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];

    return items.some(function (item) {
      return isGiftCartItem(item) && String(item && (item.variant_id || item.id)) === String(variantId);
    });
  }

  function isGiftCartItem(item) {
    var properties = item && item.properties;
    return Boolean(properties && String(properties._km_cart_gift) === 'true');
  }

  function isWhiteListProduct(item) {
    var sku = String(item && item.sku || '').trim().toUpperCase();

    if (!sku) {
      return false;
    }

    return whiteListPro.some(function (whiteListSku) {
      return String(whiteListSku || '').trim().toUpperCase() === sku;
    });
  }

  function hasWhiteListCartItem(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];

    return items.some(function (item) {
      return !isGiftCartItem(item) && isWhiteListProduct(item);
    });
  }

  function normalizePluginCartSnapshot(cart) {
    var snapshot = cart;

    if (snapshot && !Array.isArray(snapshot.items)) {
      snapshot = snapshot.cart
        || (snapshot.detail && (snapshot.detail.cart || snapshot.detail))
        || (snapshot.data && (snapshot.data.cart || snapshot.data));
    }

    if (!snapshot || !Array.isArray(snapshot.items)) {
      return null;
    }

    var itemCount = Number(snapshot.item_count);

    if (!Number.isFinite(itemCount)) {
      itemCount = snapshot.items.reduce(function (count, item) {
        return count + Math.max(0, Number(item && item.quantity) || 0);
      }, 0);
    }

    if (itemCount < 1 || snapshot.items.length < 1) {
      return Object.assign({}, snapshot, {
        items: [],
        item_count: 0,
        total_price: 0
      });
    }

    return Object.assign({}, snapshot, {
      item_count: itemCount,
      total_price: Math.max(0, Number(snapshot.total_price) || 0)
    });
  }

  function getCartTotalWithoutGift(cart) {
    var totalPrice = Number(cart && cart.total_price) || 0;
    var items = Array.isArray(cart && cart.items) ? cart.items : [];

    if (Number(cart && cart.item_count) === 0 || items.length < 1) {
      return 0;
    }

    return Math.max(0, items.reduce(function (subtotal, item) {
      if (!isGiftCartItem(item) && !isWhiteListProduct(item)) {
        return subtotal;
      }

      var linePrice;

      if (item.final_line_price !== undefined && item.final_line_price !== null) {
        linePrice = Number(item.final_line_price);
      } else if (item.line_price !== undefined && item.line_price !== null) {
        linePrice = Number(item.line_price);
      } else {
        linePrice = Number(item.original_line_price);
      }

      return subtotal - (Number.isFinite(linePrice) ? linePrice : 0);
    }, totalPrice));
  }

  function getGiftCartItems(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];

    return items.filter(isGiftCartItem);
  }

  function getManagedGiftCartItems(cart) {
    return getGiftCartItems(cart).filter(function (item) {
      return Boolean(findGiftByVariantId(item && (item.variant_id || item.id)));
    });
  }

  function getElementAttribute(element, names) {
    if (!element) {
      return '';
    }

    for (var nameIndex = 0; nameIndex < names.length; nameIndex += 1) {
      var value = element.getAttribute(names[nameIndex]);

      if (value) {
        return String(value).trim();
      }
    }

    return '';
  }

  function getLineItemElement(actions) {
    if (!actions) {
      return null;
    }

    var lineItemSelectors = [
      '[data-essential-cart-element="line-item"]',
      '[data-essential-cart-element="cart-drawer-line-item"]',
      '[data-line-item-key]',
      '[data-cart-line-item-key]',
      '[data-key]',
      '[data-item-key]',
      '[data-cart-item-key]'
    ];

    for (var selectorIndex = 0; selectorIndex < lineItemSelectors.length; selectorIndex += 1) {
      var lineItem = actions.closest(lineItemSelectors[selectorIndex]);

      if (lineItem) {
        return lineItem;
      }
    }

    var drawerContent = actions.closest(drawerContentSelector);
    var candidate = actions.parentElement;

    while (candidate && candidate !== drawerContent) {
      if (
        candidate.querySelectorAll(lineItemActionsSelector).length === 1
        && candidate.querySelector('a[href*="/products/"], [data-km-gift-product-link], [data-variant-id], [data-product-variant-id]')
      ) {
        return candidate;
      }

      candidate = candidate.parentElement;
    }

    var semanticLineItem = actions.closest('li, article');
    if (semanticLineItem) {
      return semanticLineItem;
    }

    return actions.parentElement;
  }

  function getLineItemIdentity(element) {
    var key = getElementAttribute(element, [
      'data-line-item-key',
      'data-cart-line-item-key',
      'data-item-key',
      'data-cart-item-key',
      'data-key'
    ]);
    var variantId = getElementAttribute(element, [
      'data-variant-id',
      'data-product-variant-id',
      'data-line-item-variant-id'
    ]);
    var handle = '';

    if (!key && element) {
      var keyElement = element.querySelector('[data-line-item-key], [data-cart-line-item-key], [data-item-key], [data-cart-item-key], [data-key]');
      key = getElementAttribute(keyElement, [
        'data-line-item-key',
        'data-cart-line-item-key',
        'data-item-key',
        'data-cart-item-key',
        'data-key'
      ]);
    }

    if (!variantId && element) {
      var variantElement = element.querySelector('[data-variant-id], [data-product-variant-id], [data-line-item-variant-id]');
      variantId = getElementAttribute(variantElement, [
        'data-variant-id',
        'data-product-variant-id',
        'data-line-item-variant-id'
      ]);
    }

    if (element) {
      var productLink = element.querySelector('a[href*="/products/"], [data-km-gift-product-link]');
      var productHref = productLink && (
        productLink.getAttribute('href')
        || productLink.getAttribute('data-km-gift-product-link-href')
      );
      var handleMatch = productHref && productHref.match(/\/products\/([^/?#]+)/i);
      var variantMatch = productHref && productHref.match(/[?&]variant=(\d+)/i);

      if (handleMatch) {
        handle = decodeURIComponent(handleMatch[1]);
      }

      if (!variantId && variantMatch) {
        variantId = variantMatch[1];
      }
    }

    return {
      key: key,
      variantId: variantId,
      handle: handle
    };
  }

  function findCartItemForElement(actions, cartItems, actionIndex, actionCount) {
    var lineItem = getLineItemElement(actions);
    var actionIdentity = getLineItemIdentity(actions);
    var lineItemIdentity = getLineItemIdentity(lineItem);
    var itemKey = actionIdentity.key || lineItemIdentity.key;
    var variantId = actionIdentity.variantId || lineItemIdentity.variantId;
    var handle = actionIdentity.handle || lineItemIdentity.handle;

    if (itemKey) {
      var keyMatch = cartItems.find(function (item) {
        return String(item && item.key || '') === itemKey;
      });

      if (keyMatch) {
        return keyMatch;
      }

    }

    if (actionCount === cartItems.length && cartItems[actionIndex]) {
      var positionalItem = cartItems[actionIndex];
      var positionalVariantId = String(positionalItem && (positionalItem.variant_id || positionalItem.id) || '');
      var positionalHandle = String(positionalItem && positionalItem.handle || '');

      if (
        (!variantId || positionalVariantId === variantId)
        && (!handle || positionalHandle === handle)
      ) {
        return positionalItem;
      }
    }

    if (variantId) {
      var variantMatches = cartItems.filter(function (item) {
        return String(item && (item.variant_id || item.id) || '') === variantId;
      });

      if (variantMatches.length === 1) {
        return variantMatches[0];
      }
    }

    if (handle) {
      var handleMatches = cartItems.filter(function (item) {
        return String(item && item.handle || '') === handle;
      });

      if (handleMatches.length === 1) {
        return handleMatches[0];
      }
    }

    return null;
  }

  function setHiddenState(element, shouldHide) {
    if (!element) {
      return;
    }

    element.hidden = shouldHide;
    element.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  }

  function syncGiftLineItemProductLinks(lineItem, isGiftItem) {
    if (!lineItem) {
      return;
    }

    var productLinks = lineItem.querySelectorAll('[data-km-gift-product-link], a[href*="/products/"]');

    productLinks.forEach(function (productLink) {
      if (isGiftItem) {
        var productHref = productLink.getAttribute('href');

        if (productHref && !productLink.hasAttribute('data-km-gift-product-link-href')) {
          productLink.setAttribute('data-km-gift-product-link-href', productHref);
        }

        productLink.setAttribute('data-km-gift-product-link', '');
        productLink.setAttribute('aria-disabled', 'true');
        productLink.removeAttribute('href');
        return;
      }

      var originalHref = productLink.getAttribute('data-km-gift-product-link-href');

      if (originalHref) {
        productLink.setAttribute('href', originalHref);
      }

      productLink.removeAttribute('data-km-gift-product-link');
      productLink.removeAttribute('data-km-gift-product-link-href');
      productLink.removeAttribute('aria-disabled');
    });
  }

  function getCartItemVariantTitle(cartItem) {
    var variantTitle = cartItem && typeof cartItem.variant_title === 'string'
      ? cartItem.variant_title.trim()
      : '';

    if (!variantTitle && cartItem && Array.isArray(cartItem.variant_options)) {
      variantTitle = cartItem.variant_options.filter(Boolean).join(' / ').trim();
    }

    return variantTitle && variantTitle.toLowerCase() !== 'default title' ? variantTitle : '';
  }

  function syncGiftLineItemVariantSelectors(lineItem, isGiftItem, cartItem) {
    if (!lineItem) {
      return;
    }

    var variantSelectors = lineItem.querySelectorAll(lineItemVariantSelector);
    var variantText = lineItem.querySelector('[data-km-gift-line-item-variant]');

    variantSelectors.forEach(function (variantSelector) {
      if (isGiftItem) {
        if (!variantSelector.hasAttribute('data-km-gift-variant-selector')) {
          variantSelector.setAttribute('data-km-gift-original-hidden', variantSelector.hidden ? 'true' : 'false');
          variantSelector.setAttribute(
            'data-km-gift-original-aria-hidden',
            variantSelector.hasAttribute('aria-hidden') ? variantSelector.getAttribute('aria-hidden') : '__none__'
          );
        }

        variantSelector.setAttribute('data-km-gift-variant-selector', '');
        variantSelector.hidden = true;
        variantSelector.setAttribute('aria-hidden', 'true');
        return;
      }

      var originalHidden = variantSelector.getAttribute('data-km-gift-original-hidden');
      var originalAriaHidden = variantSelector.getAttribute('data-km-gift-original-aria-hidden');

      if (originalHidden !== null) {
        variantSelector.hidden = originalHidden === 'true';
      }

      if (originalAriaHidden === '__none__') {
        variantSelector.removeAttribute('aria-hidden');
      } else if (originalAriaHidden !== null) {
        variantSelector.setAttribute('aria-hidden', originalAriaHidden);
      }

      variantSelector.removeAttribute('data-km-gift-original-hidden');
      variantSelector.removeAttribute('data-km-gift-original-aria-hidden');
      variantSelector.removeAttribute('data-km-gift-variant-selector');
    });

    if (!isGiftItem) {
      if (variantText) {
        variantText.remove();
      }
      return;
    }

    var variantTitle = getCartItemVariantTitle(cartItem);

    if (!variantTitle || !variantSelectors.length) {
      if (variantText) {
        variantText.remove();
      }
      return;
    }

    if (!variantText) {
      variantText = document.createElement('span');
      variantText.setAttribute('data-km-gift-line-item-variant', '');
      variantText.className = 'km-gift-line-item-variant';
      variantSelectors[0].insertAdjacentElement('afterend', variantText);
    }

    variantText.textContent = variantTitle;
  }

  function blockGiftLineItemNavigation(event) {
    var lineItem = event.target.closest('[data-km-gift-line-item]');

    if (!lineItem) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function syncGiftLineItemActions(cart) {
    var cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    var actionElements = document.querySelectorAll(lineItemActionsSelector);

    actionElements.forEach(function (actions, actionIndex) {
      var cartItem = findCartItemForElement(actions, cartItems, actionIndex, actionElements.length);
      var isGiftItem = isGiftCartItem(cartItem);
      var lineItem = getLineItemElement(actions);
      var quantityLabel = lineItem
        ? lineItem.querySelector('[data-km-gift-line-item-quantity]')
        : null;

      if (!isGiftItem) {
        setHiddenState(actions, false);
        if (lineItem) {
          lineItem.removeAttribute('data-km-gift-line-item');
        }
        syncGiftLineItemProductLinks(lineItem, false);
        syncGiftLineItemVariantSelectors(lineItem, false, cartItem);
        if (quantityLabel) {
          quantityLabel.remove();
        }
        return;
      }

      setHiddenState(actions, true);
      if (lineItem) {
        lineItem.setAttribute('data-km-gift-line-item', '');
      }
      syncGiftLineItemProductLinks(lineItem, true);
      syncGiftLineItemVariantSelectors(lineItem, true, cartItem);

      if (!quantityLabel) {
        quantityLabel = document.createElement('span');
        quantityLabel.setAttribute('data-km-gift-line-item-quantity', '');
        quantityLabel.className = 'km-gift-line-item-quantity';
        quantityLabel.textContent = 'x1';
        actions.insertAdjacentElement('beforebegin', quantityLabel);
      }

      setHiddenState(quantityLabel, false);
      quantityLabel.textContent = 'x1';
    });
  }

  function scheduleGiftLineItemSync(cart) {
    window.clearTimeout(giftLineItemSyncTimer);
    var delays = [0, 80, 220, 500, 1000];

    function runSync(syncIndex) {
      giftLineItemSyncTimer = window.setTimeout(function () {
        syncGiftLineItemActions(cart || lastCart);

        if (syncIndex + 1 < delays.length) {
          runSync(syncIndex + 1);
        }
      }, delays[syncIndex]);
    }

    runSync(0);
  }

  function getRegularCartSignature(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];

    return items.filter(function (item) {
      return !isGiftCartItem(item);
    }).map(function (item) {
      return [item.key || item.id, item.quantity].join(':');
    }).join('|');
  }

  function getInvalidGiftCartItems(cart) {
    var totalPrice = getCartTotalWithoutGift(cart);

    return getGiftCartItems(cart).filter(function (item) {
      var variantId = item && (item.variant_id || item.id);
      var match = findGiftByVariantId(variantId);

      return Boolean(match) && totalPrice < match.gift.threshold;
    });
  }

  function removeInvalidGiftCartItems(cart, forceCleanup) {
    var invalidGiftItems = getInvalidGiftCartItems(cart);
    var updates = {};

    if (!forceCleanup && (checkoutPending || checkoutHandoff || giftSelectionPending)) {
      return Promise.resolve(cart);
    }

    if (!invalidGiftItems.length) {
      return Promise.resolve(cart);
    }

    if (cleanupRequest) {
      return cleanupRequest;
    }

    invalidGiftItems.forEach(function (item) {
      if (item && item.key) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }

    lastGiftRestoreSignature = null;
    cleanupRequest = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to remove invalid gift items');
        }
        return response.json();
      })
      .catch(function () {
        return cart;
      })
      .finally(function () {
        cleanupRequest = null;
      });

    return cleanupRequest;
  }

  function removeGiftCartItems(cart, forceCleanup) {
    var giftItems = getManagedGiftCartItems(cart);
    var updates = {};

    if (!giftItems.length || (!forceCleanup && (checkoutPending || checkoutHandoff || giftSelectionPending))) {
      return Promise.resolve(cart);
    }

    if (cleanupRequest) {
      return cleanupRequest;
    }

    giftItems.forEach(function (item) {
      if (item && item.key) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }

    cleanupRequest = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to remove gift items');
        }
        return response.json();
      })
      .catch(function () {
        return cart;
      })
      .finally(function () {
        cleanupRequest = null;
      });

    return cleanupRequest;
  }

  function getCheckoutGiftMatch(cart) {
    var match = resolveSelectedGift(cart);
    var totalPrice = getCartTotalWithoutGift(cart);

    if (!match || totalPrice < match.gift.threshold) {
      return null;
    }

    return match;
  }

  function hasSelectedGift() {
    var storedSelection = selectedGift || loadSelectedGift();
    return Boolean(storedSelection && storedSelection.variantId);
  }

  function continueCheckout(button) {
    checkoutBypass = true;
    checkoutHandoff = true;
    window.clearTimeout(checkoutHandoffTimer);

    window.setTimeout(function () {
      var currentButton = document.querySelector(checkoutButtonSelector) || button;
      currentButton.click();
    }, 0);
  }

  function handleCheckoutClick(event) {
    var button = event.target.closest(checkoutButtonSelector);

    if (!button || checkoutBypass || checkoutPending) {
      return;
    }

    if (!hasSelectedGift()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    checkoutPending = true;
    checkoutHandoff = true;
    window.clearTimeout(checkoutHandoffTimer);
    button.setAttribute('aria-busy', 'true');

    getCart()
      .then(function (cart) {
        if (!cart) {
          throw new Error('Unable to load cart before checkout');
        }

        return removeInvalidGiftCartItems(cart, true);
      })
      .then(function (cart) {
        var match = getCheckoutGiftMatch(cart);
        var giftItems = getManagedGiftCartItems(cart);

        if (!match) {
          return cart;
        }

        if (cartHasGiftVariant(cart, match.variant.id) && giftItems.length === 1) {
          return cart;
        }

        return removeGiftCartItems(cart, true)
          .then(function () {
            return addGiftVariantToCart(match.variant.id);
          });
      })
      .then(function () {
        return refreshEssentialCart();
      })
      .then(function () {
        checkoutPending = false;
        button.removeAttribute('aria-busy');
        continueCheckout(button);
      })
      .catch(function () {
        checkoutPending = false;
        checkoutHandoff = false;
        button.removeAttribute('aria-busy');
      });
  }

  function selectedGiftMarkup(match, unlocked, totalPrice) {
    var gift = match.gift;
    var variant = match.variant;
    var label = getVariantLabel(variant);
    var option = label && label !== 'Default Title' ? '<p>Option: ' + escapeHtml(label) + '</p>' : '';
    var selectedImage = variant && variant.image ? variant.image : gift.image;
    var lockedMessage = unlocked
      ? ''
      : '<p class="km-selected-gift__locked">Spend ' + escapeHtml(formatMoney(Math.max(0, gift.threshold - totalPrice))) + ' more to unlock</p>';
    var image = selectedImage
      ? '<img class="km-selected-gift__image" src="' + escapeHtml(selectedImage) + '" alt="' + escapeHtml(gift.title) + '" loading="lazy">'
      : '<div class="km-selected-gift__image km-selected-gift__image--empty"></div>';

    return [
      '<div class="km-selected-gift__inner">',
      image,
      '<div class="km-selected-gift__body">',
      '<strong>' + escapeHtml(gift.title) + '</strong>',
      option,
      lockedMessage,
      '<div class="km-selected-gift__price"><span>Free</span><s>' + escapeHtml(formatMoney(gift.comparePrice || gift.price)) + '</s></div>',
      '</div>',
      '<button class="km-selected-gift__change" type="button" data-km-gift-change>Change</button>',
      '</div>'
    ].join('');
  }

  function renderSelectedGift(component, cart) {
    var selectedContainer = component.querySelector('[data-km-selected-gift]');
    var openButton = component.querySelector('[data-km-gift-open]');
    var match = resolveSelectedGift(cart);
    var totalPrice = getCartTotalWithoutGift(cart);
    var unlocked = match && totalPrice >= match.gift.threshold;

    if (!selectedContainer) {
      return;
    }

    if (!match) {
      selectedContainer.classList.remove('is-locked');
      setHiddenState(selectedContainer, true);
      selectedContainer.innerHTML = '';
      if (openButton) {
        setHiddenState(openButton, false);
      }
      return;
    }

    selectedContainer.classList.toggle('is-locked', !unlocked);
    setHiddenState(selectedContainer, false);
    selectedContainer.innerHTML = selectedGiftMarkup(match, unlocked, totalPrice);
    if (openButton) {
      setHiddenState(openButton, true);
    }
  }

  function syncGiftProgressState(component, cart) {
    if (!component || !cart) {
      return;
    }

    var totalPrice = getCartTotalWithoutGift(cart);
    var firstThreshold = thresholds[0];
    var finalThreshold = thresholds[thresholds.length - 1] || maximumThreshold;
    var progress;

    if (totalPrice <= 0) {
      progress = 0;
    } else if (totalPrice < firstThreshold) {
      progress = (totalPrice / firstThreshold) * 50;
    } else if (totalPrice < finalThreshold) {
      progress = 50 + ((totalPrice - firstThreshold) / (finalThreshold - firstThreshold)) * 50;
    } else {
      progress = 100;
    }
    var message = component.querySelector('[data-km-gift-message]');
    var progressBar = component.querySelector('[data-km-gift-progress]');

    if (message) {
      message.textContent = getStatus(totalPrice);
    }

    if (progressBar) {
      progressBar.style.width = progress + '%';
    }

    component.querySelectorAll('[data-km-gift-milestone]').forEach(function (milestone, index) {
      milestone.classList.toggle('is-unlocked', totalPrice >= thresholds[index]);
    });
    setHiddenState(
      component.querySelector('[data-km-gift-exclusion-notice]'),
      !hasWhiteListCartItem(cart)
    );
  }

  function render(cart) {
    var drawerContent = document.querySelector(drawerContentSelector);
    var component = drawerContent ? drawerContent.querySelector(componentSelector) : null;
    var dialog = document.querySelector(dialogSelector);

    if (!cart) {
      syncGiftLineItemActions(null);
      resetCartGiftState();
      return;
    }

    if (cart.item_count < 1) {
      clearSelectedGift();
      syncGiftLineItemActions(null);
    }

    if (!initialCartSync) {
      maybeAutoOpenGiftDialog(cart);
    }

    if (!drawerContent) {
      return;
    }

    if (!component) {
      component = buildComponent();
      drawerContent.insertAdjacentElement('afterbegin', component);
    } else if (drawerContent.firstElementChild !== component) {
      drawerContent.insertAdjacentElement('afterbegin', component);
    }

    syncGiftProgressState(component, cart);
    renderSelectedGift(component, cart);
    scheduleGiftLineItemSync(cart);

    if (!giftEntryViewTracked) {
      giftEntryViewTracked = true;
      trackGiftEvent('view_gift_entry');
    }

    dialog = dialog || buildDialog();

    if (activeGiftIndex == null) {
      renderGiftList(dialog, cart);
    } else {
      renderGiftDetail(dialog, activeGiftIndex);
    }

  }

  function fetchCartSnapshot() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load cart');
      }
      return response.json();
    });
  }

  function getCart() {
    if (cartRequest) {
      refreshQueued = true;
      return cartRequest;
    }

    cartRequest = fetchCartSnapshot()
      .then(function (cart) {
        return removeInvalidGiftCartItems(cart);
      })
      .then(function (cart) {
        return restoreSelectedGiftCartItem(cart);
      })
      .then(function (cart) {
        lastCart = cart;
        render(cart);
        scheduleGiftLineItemSync(cart);
        return cart;
      })
      .catch(function () {})
      .finally(function () {
        cartRequest = null;
        if (refreshQueued) {
          refreshQueued = false;
          scheduleRefresh();
        }
      });

    return cartRequest;
  }

  function syncCartAfterPluginUpdate() {
    if (cartSyncRequest) {
      cartSyncQueued = true;
      return cartSyncRequest;
    }

    cartSyncPending = true;
    cartSyncRequest = fetchCartSnapshot()
      .then(function (cart) {
        if (!cart) {
          return null;
        }

        latestPluginCart = cart;
        return removeInvalidGiftCartItems(cart);
      })
      .then(function (cart) {
        return restoreSelectedGiftCartItem(cart);
      })
      .then(function (cart) {
        lastCart = cart;
        render(cart);
        scheduleGiftLineItemSync(cart);
        return cart;
      })
      .catch(function () {})
      .finally(function () {
        cartSyncRequest = null;
        cartSyncPending = false;

        if (cartSyncQueued) {
          cartSyncQueued = false;
          scheduleRefresh();
        }
      });

    return cartSyncRequest;
  }

  function scheduleRefresh() {
    if (initialCartSync || checkoutPending || checkoutHandoff || giftSelectionPending) {
      return;
    }

    if (cartSyncPending) {
      cartSyncQueued = true;
      return;
    }

    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(syncCartAfterPluginUpdate, 120);
    startContainerSync();
  }

  function installPluginCartListener() {
    if (pluginCartListenerInstalled) {
      return;
    }

    var essentialCartApi = window.essentialCartApi;

    if (essentialCartApi && typeof essentialCartApi.onCartUpdate === 'function') {
      pluginCartUnsubscribe = essentialCartApi.onCartUpdate(function (cart) {
        var pluginCart = normalizePluginCartSnapshot(cart);

        latestPluginCart = pluginCart || cart;
        scheduleGiftLineItemSync(pluginCart || cart);

        if (initialCartSync || checkoutPending || checkoutHandoff || giftSelectionPending) {
          return;
        }

        if (pluginCart) {
          lastCart = pluginCart;
          render(pluginCart);
          startContainerSync();
        }

        scheduleRefresh();
      });
      pluginCartListenerInstalled = true;
      window.clearTimeout(pluginCartListenerTimer);
      pluginCartListenerTimer = null;
      return;
    }

    pluginCartListenerTimer = window.setTimeout(installPluginCartListener, 100);
  }

  function startContainerSync() {
    window.clearTimeout(containerSyncStopTimer);

    if (!containerSyncTimer) {
      containerSyncTimer = window.setInterval(function () {
        var drawerContent = document.querySelector(drawerContentSelector);

        if (!drawerContent || !lastCart) {
          return;
        }

        syncGiftLineItemActions(lastCart);

        var component = drawerContent.querySelector(componentSelector);

        if (!component) {
          render(lastCart);
          return;
        }

        syncGiftProgressState(component, lastCart);
      }, 300);
    }

    containerSyncStopTimer = window.setTimeout(function () {
      window.clearInterval(containerSyncTimer);
      containerSyncTimer = null;
    }, 8000);
  }

  function installGiftOptionClickListener() {
    if (clickListenerInstalled) {
      return;
    }

    clickListenerInstalled = true;
    document.addEventListener('click', handleCheckoutClick, true);
    document.addEventListener('click', blockGiftLineItemNavigation, true);
    document.addEventListener('auxclick', blockGiftLineItemNavigation, true);
    document.addEventListener('click', function (event) {
      var helpButton = event.target.closest('[data-km-gift-help]');
      var component = document.querySelector(componentSelector);
      var tooltip = component ? component.querySelector('[data-km-gift-help-tooltip]') : null;
      var activeHelpButton = component ? component.querySelector('[data-km-gift-help]') : null;

      if (helpButton && tooltip) {
        event.preventDefault();
        event.stopPropagation();
        tooltip.hidden = !tooltip.hidden;
        helpButton.setAttribute('aria-expanded', String(!tooltip.hidden));
        return;
      }

      if (tooltip && !tooltip.hidden && !event.target.closest('[data-km-gift-help-tooltip]')) {
        tooltip.hidden = true;
        activeHelpButton.setAttribute('aria-expanded', 'false');
      }

      var button = event.target.closest('[data-km-gift-open], [data-km-gift-change]');

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      var isGiftEntryButton = button.matches('[data-km-gift-open]');

      if (isGiftEntryButton) {
        trackGiftEvent('click_gift_options');
      } else if (button.matches('[data-km-gift-change]')) {
        trackGiftEvent('click_change_gift');
      }

      activeGiftIndex = null;
      giftDialogOpenedAutomatically = false;
      openDialog();

      if (isGiftEntryButton) {
        trackGiftEvent('view_gift_selection_modal');
      }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') {
        return;
      }

      var component = document.querySelector(componentSelector);
      var tooltip = component ? component.querySelector('[data-km-gift-help-tooltip]') : null;
      if (tooltip && !tooltip.hidden) {
        tooltip.hidden = true;
        component.querySelector('[data-km-gift-help]').setAttribute('aria-expanded', 'false');
      }
    });
  }

  function addStyles() {
    if (document.getElementById('km-essential-cart-content-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'km-essential-cart-content-style';
    style.textContent = [
      '.km-cart-gifts{box-sizing:border-box;margin:0 20px 16px;padding:14px;border:1px solid #d2d2d2;background:#fff;color:#161616;font-family:inherit}',
      '.km-cart-gifts__message{position:relative;display:flex;align-items:center;gap:10px;min-height:32px;font-size:14px;line-height:1.35}',
      '.km-cart-gifts__message strong{min-width:0;flex:1}',
      '.km-cart-gifts__help{display:grid;place-items:center;flex:0 0 24px;width:24px;height:24px;margin-left:auto;padding:0;border:1px solid #777;border-radius:50%;background:#fff;color:#161616;font:700 14px/1 Arial,sans-serif;cursor:pointer}',
      '.km-cart-gifts__help:focus-visible{outline:2px solid #e4002b;outline-offset:2px}',
      '.km-cart-gifts__tooltip[hidden]{display:none!important}',
      '.km-cart-gifts__tooltip{box-sizing:border-box;position:absolute;z-index:10;top:calc(100% + 4px);right:0;width:min(320px,100%);padding:12px;border:1px solid #d2d2d2;background:#fff;box-shadow:0 4px 16px rgba(0,0,0,.16);font-size:14px;line-height:1.45;border-radius: 6px;}',
      '.km-cart-gifts__tooltip ol{margin:0;padding-left:18px}',
      '.km-cart-gifts__tooltip li+li{margin-top:8px}',
      '.km-cart-gifts__icon{display:grid;place-items:center;flex:0 0 32px;width:32px;height:32px;background:#fff0f3;font-size:16px}',
      '.km-cart-gifts__progress{position:relative;height:25px;margin:10px 10px 15px}',
      '.km-cart-gifts__track,.km-cart-gifts__fill{position:absolute;top:4px;left:0;height:4px}',
      '.km-cart-gifts__track{right:0;background:#e4e4e4}',
      '.km-cart-gifts__fill{z-index:1;max-width:100%;background:#e4002b;transition:width .25s ease}',
      '.km-cart-gifts__milestone{position:absolute;z-index:2;top:-1px;transform:translateX(-50%);font-size:10px;color:#777;text-align:center}',
      '.km-cart-gifts__milestone--first{left:50%}',
      '.km-cart-gifts__milestone--second{left:100%}',
      '.km-cart-gifts__milestone i{display:block;width:12px;height:12px;margin:0 auto 3px;border:2px solid #c5c5c5;border-radius:50%;background:#fff}',
      '.km-cart-gifts__milestone.is-unlocked i{border-color:#e4002b;background:#e4002b}',
      '.km-cart-gifts__milestone b{font-weight:400;font-size: 12px;}',
      '.km-cart-gifts__selected{margin:12px 0 14px;border:1px solid #d8d8d8;background:#fff}',
      '.km-cart-gifts__button[hidden],[data-km-gift-exclusion-notice][hidden],.km-gift-dialog__back[hidden],[data-km-gift-dialog-subtitle][hidden],[data-km-gift-remind-later][hidden],[data-km-selected-gift][hidden],[data-km-gift-line-item-quantity][hidden],[data-essential-cart-element="line-item-actions"][hidden],[data-km-gift-line-item] [data-essential-cart-element="line-item-actions"]{display:none!important}',
      '.km-cart-gifts__selected.is-locked{border-color:#c7c7c7;background:#efefef}',
      '.km-cart-gifts__selected.is-locked .km-selected-gift__inner{opacity:.52}',
      '.km-cart-gifts__selected.is-locked .km-selected-gift__image{filter:grayscale(1)}',
      '.km-selected-gift__inner{display:grid;grid-template-columns:52px minmax(0,1fr) auto;align-items:center;gap:10px;padding:10px}',
      '.km-selected-gift__image{display:block;width:52px;height:52px;object-fit:cover;background:#f3f3f3}',
      '.km-selected-gift__image--empty{background:#eee}',
      '.km-selected-gift__body{min-width:0}',
      '.km-selected-gift__body strong{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;color:#171717;font-size:14px;line-height:1.25;font-weight:800;text-overflow:ellipsis;overflow-wrap:break-word}',
      '.km-selected-gift__body p{margin:4px 0 0;color:#777;font-size:11px;line-height:1.2}',
      '.km-selected-gift__body .km-selected-gift__locked{color:#555;font-weight:700}',
      '.km-selected-gift__price{display:flex;align-items:center;gap:7px;margin-top:5px;font-size:14px;line-height:1}',
      '.km-selected-gift__price s{color:#777}',
      '.km-selected-gift__price span{color:#e4002b;font-weight:800;text-transform:uppercase}',
      '.km-selected-gift__change{align-self:center;padding:4px 0;border:0;background:transparent;color:#171717;font-family:inherit;font-size:10px;font-weight:800;text-decoration:underline;text-transform:none;cursor:pointer}',
      '.km-cart-gifts__button{position:relative;z-index:3;display:flex;align-items:center;justify-content:space-between;width:100%;min-height:44px;padding:0 14px;border-radius:0;background:#e4002b;color:#fff;font-family:inherit;font-size:11px;font-weight:700;line-height:1;text-transform:uppercase;cursor:pointer;pointer-events:auto}',
      '.km-cart-gifts__exclusion-notice{margin:8px 0 0;color:#666;font-size:11px;line-height:1.4}',
      '.km-gift-line-item-quantity{display:inline-flex;align-items:center;justify-content:center;min-width:28px;color:inherit;font-size:12px;font-weight:700;line-height:1}',
      '.km-gift-line-item-variant{display:block;margin-top:4px;color:#666;font-size:12px;line-height:1.35}',
      '[data-km-gift-variant-selector]{display:none!important}',
      '[data-km-gift-product-link]{color:inherit;text-decoration:none;cursor:default}',
      '.km-cart-gifts__chevron{width:8px;height:8px;border-top:2px solid currentColor;border-right:2px solid currentColor;transform:rotate(45deg)}',
      '.km-gift-dialog[hidden]{display:none!important}',
      '.km-gift-dialog{box-sizing:border-box;position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:20px;overflow:auto;background:rgba(0,0,0,.48);color:#171717}',
      '.km-gift-dialog__panel{box-sizing:border-box;width:min(760px,100%);max-height:calc(100vh - 40px);padding:20px;overflow:auto;border-radius:6px;background:#fff;outline:none}',
      '.km-gift-dialog.is-detail{overflow:hidden}',
      '.km-gift-dialog.is-detail .km-gift-dialog__panel{display:flex;flex-direction:column;max-height:calc(100vh - 40px)}',
      '.km-gift-dialog.is-detail .km-gift-dialog__body{min-height:0;overflow:hidden}',
      '.km-gift-dialog__header{display:grid;grid-template-columns:160px minmax(0,1fr) 40px;align-items:start;gap:20px;margin-bottom:24px}',
      '.km-gift-dialog__header h2{margin:0;text-align:center;font-size:26px;line-height:1.15;font-weight:800;text-transform:uppercase;letter-spacing:0}',
      '.km-gift-dialog__header p{margin:5px 0 0;color:#777;font-size:11px}',
      '.km-gift-dialog__remind-later{display:block;margin:18px auto 0;padding:6px 0;border:0;background:transparent;color:#000;font-family:inherit;font-size:14px;text-decoration:underline;cursor:pointer}',
      '.km-gift-dialog:not(.is-detail) .km-gift-dialog__header{grid-template-columns:minmax(0,1fr) 40px}',
      '.km-gift-dialog:not(.is-detail) .km-gift-dialog__header h2,.km-gift-dialog:not(.is-detail) .km-gift-dialog__header p{text-align:left}',
      '.km-gift-dialog.is-detail .km-gift-dialog__header{position:relative;grid-template-columns:minmax(0,1fr) 40px}',
      '.km-gift-dialog.is-detail .km-gift-dialog__header>div{grid-column:1/-1;grid-row:1;min-width:0;text-align:center}',
      '.km-gift-dialog.is-detail .km-gift-dialog__header h2,.km-gift-dialog.is-detail .km-gift-dialog__header p{text-align:center}',
      '.km-gift-dialog.is-detail .km-gift-dialog__back{position:absolute;top:0;left:0;z-index:1}',
      '.km-gift-dialog.is-detail .km-gift-dialog__close{grid-column:2;grid-row:1;justify-self:end;z-index:1}',
      '.km-gift-dialog__back{justify-self:start;padding:8px 0;border:0;background:transparent;color:#161616;font-family:inherit;font-size:10px;font-weight:800;line-height:1;text-transform:uppercase;cursor:pointer}',
      '.km-gift-dialog__back:before{content:"\\2190";display:inline-block;margin-right:8px;font-size:13px;line-height:1}',
      '.km-gift-dialog__close{flex:0 0 36px;width:36px;height:36px;padding:0;border:0;background:transparent;color:#161616;font:400 32px/32px Arial,sans-serif;cursor:pointer}',
      '.km-gift-dialog__grid{display:grid;grid-template-columns:repeat(3,minmax(0,317px));justify-content:center;gap:16px}',
      '.km-gift-dialog__empty{grid-column:1/-1;margin:30px 0;color:#777;text-align:center}',
      '.km-gift-card{border:1px solid #cfcfcf;background:#fff}',
      '.km-gift-card__image-wrap{position:relative;background:#fff;aspect-ratio:1/1;overflow:hidden}',
      '.km-gift-card__image{display:block;width:100%;height:100%;object-fit:contain;transition:filter .2s ease,opacity .2s ease}',
      '.km-gift-card__image--empty{background:#eee}',
      '.km-gift-card.is-locked .km-gift-card__image{filter:grayscale(1);opacity:.45}',
      '.km-gift-card__tier{position:absolute;z-index:1;top:0;left:0;padding:4px;background:#555;color:#fff;font-size:10px;font-weight:800;text-transform:uppercase}',
      '.km-gift-card__body{display:flex;flex-direction:column;padding:10px}',
      '.km-gift-card__body h3{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;min-height:35px;max-height:35px;margin:0 0 10px;overflow:hidden;font-size:13px;line-height:1.35;font-weight:800;letter-spacing:0;text-overflow:ellipsis;overflow-wrap:break-word}',
      '.km-gift-card__price{display:flex;align-items:flex-end;gap:6px;margin:0 0 9px;font-size:12px}',
      '.km-gift-card__price s{color:#888}',
      '.km-gift-card__price strong{font-size: 16px;}',
      '.km-gift-card__price strong,.km-gift-card__unlocked{color:#e4002b;text-transform:uppercase}',
      '.km-gift-card__status{margin:0 0 10px;color:#888;font-size:11px}',
      '.km-gift-card__details{display:grid;place-items:center;margin-top:auto;padding:0 10px;border-radius: 6px;background:#e4002b;color:#fff;font-family:inherit;font-size:12px;font-weight:700;text-decoration:none;text-transform:uppercase;cursor:pointer;padding: 10px;}',
      '.km-gift-detail{display:grid;grid-template-columns:minmax(0,1fr) minmax(320px,.95fr);grid-template-rows:minmax(0,1fr) auto;height:min(600px,calc(100vh - 150px));min-height:0;gap:20px 28px}',
      '.km-gift-detail__media{position:relative;min-height:0;overflow:hidden;border:1px solid #e2e2e2;background:#fafafa}',
      '.km-gift-detail__badge{position:absolute;top:11px;left:11px;padding:7px 10px;background:#555;color:#fff;font-size:12px;font-weight:800;line-height:1;text-transform:uppercase;z-index: 1;}',
      '.km-gift-detail__badge.is-unlocked{background:#e4002b}',
      '.km-gift-gallery,.km-gift-gallery__viewport,.km-gift-gallery__track,.km-gift-gallery__slide{width:100%;height:100%;min-height:0}',
      '.km-gift-gallery__viewport{position:relative;overflow:hidden;touch-action:pan-y}',
      '.km-gift-gallery__track{display:flex;transition:transform .28s ease;will-change:transform}',
      '.km-gift-gallery__slide{display:grid;place-items:center;flex:0 0 100%;box-sizing:border-box}',
      '.km-gift-gallery__arrow{position:absolute;z-index:2;top:50%;display:grid;place-items:center;width:36px;height:36px;padding:0;transform:translateY(-50%);border:1px solid #d0d0d0;border-radius:50%;background:rgba(255,255,255,.92);color:#171717;font:400 28px/1 Arial,sans-serif;cursor:pointer}',
      '.km-gift-gallery__arrow--prev{left:10px}',
      '.km-gift-gallery__arrow--next{right:10px}',
      '.km-gift-gallery__dots{position:absolute;z-index:2;right:48px;bottom:13px;left:48px;display:flex;justify-content:center;gap:7px}',
      '.km-gift-gallery__dot{width:7px;height:7px;padding:0;border:0;border-radius:50%;background:#bcbcbc;cursor:pointer}',
      '.km-gift-gallery__dot.is-active{background:#e4002b}',
      '.km-gift-detail__image{display:block;width:auto;height:auto;max-width:100%;max-height:100%;object-fit:contain}',
      '.km-gift-detail__image--empty{width:68%;aspect-ratio:1/1;background:#eee}',
      '.km-gift-detail__content{min-width:0;min-height:0;padding:4px 8px 0 0;overflow-y:auto;overscroll-behavior:contain;scrollbar-gutter:stable}',
      '.km-gift-detail__content h3{margin:0 0 14px;font-size:24px;line-height:1.25;font-weight:800;letter-spacing:0}',
      '.km-gift-detail__price{display:flex;align-items:center;gap:12px;margin:0 0 24px;font-size:18px;line-height:1}',
      '.km-gift-detail__price s{color:#777;font-size:13px}',
      '.km-gift-detail__price strong{color:#e4002b;font-weight:800;text-transform:uppercase}',
      '.km-gift-detail__options{margin:0 0 20px}',
      '.km-gift-detail__options p,.km-gift-detail__description h4{margin:0 0 10px;font-size:12px;font-weight:800;text-transform:uppercase}',
      '.km-gift-detail__option-list{display:flex;flex-wrap:wrap;gap:10px}',
      '.km-gift-detail__option{min-height:44px;padding:0 18px;border:1px solid #c9c9c9;background:#fff;color:#171717;font-family:inherit;font-size:13px;font-weight:700;cursor:pointer}',
      '.km-gift-detail__option.is-selected{border-color:#e4002b;color:#e4002b}',
      '.km-gift-detail__option:disabled{opacity:.45;cursor:not-allowed}',
      '.km-gift-detail__description{padding-top:18px;border-top:1px solid #d8d8d8;color:#666;font-size:12px;line-height:1.55}',
      '.km-gift-detail__description-content{overflow-wrap:anywhere}',
      '.km-gift-detail__description-content>:first-child{margin-top:0}',
      '.km-gift-detail__description-content>:last-child{margin-bottom:0}',
      '.km-gift-detail__description-content img{display:block;max-width:100%!important;height:auto!important}',
      '.km-gift-detail__description-content iframe,.km-gift-detail__description-content video{display:block;max-width:100%}',
      '.km-gift-detail__add{grid-column:1/-1;min-height:50px;border:0;background:#e4002b;color:#fff;font-family:inherit;font-size:12px;font-weight:800;text-transform:uppercase;cursor:pointer;border-radius: 6px;}',
      '.km-gift-detail__add:disabled{background:#c9c9c9;cursor:not-allowed}',
      '.km-gift-dialog-open{overflow:hidden}',
      '@keyframes kmGiftSheetIn{from{transform:translateY(100%)}to{transform:translateY(0)}}',
      '@media(max-width:749px){.km-gift-dialog__remind-later{position:sticky;z-index:6;bottom:0;width:100%;margin:12px 0 0;padding:12px;border-top:1px solid #e5e5e5;background:#fff}}',
      '@media(max-width:749px){.km-cart-gifts{margin:0 12px 14px;padding:12px}.km-gift-dialog{place-items:end stretch;padding:0;overflow:auto}.km-gift-dialog__panel{width:100%;max-width:100%;max-height:80dvh;margin:0;padding:10px 12px 14px;overflow:auto;border-radius:10px 10px 0 0;animation:kmGiftSheetIn .22s ease-out}.km-gift-dialog__header{position:sticky;top:0;z-index:4;grid-template-columns:32px minmax(0,1fr) 32px;align-items:center;gap:8px;margin:0 -2px 14px;padding:0 0 10px;background:#fff}.km-gift-dialog:not(.is-detail) .km-gift-dialog__header{grid-template-columns:minmax(0,1fr) 32px}.km-gift-dialog.is-detail .km-gift-dialog__header{grid-template-columns:minmax(0,1fr) 32px}.km-gift-dialog__header h2{font-size:16px}.km-gift-dialog__header p{font-size:10px}.km-gift-dialog__back{width:32px;height:32px;padding:0;overflow:hidden;font-size:0}.km-gift-dialog__back:before{margin:0;font-size:21px}.km-gift-dialog__close{flex-basis:32px;width:32px;height:32px;font-size:28px;line-height:28px}.km-gift-dialog__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}.km-gift-card{min-width:0}.km-gift-card__tier{padding:5px 7px;font-size:12px}.km-gift-card__body{padding:10px}.km-gift-card__body h3{min-height:32px;max-height:32px;margin-bottom:10px;font-size:11px}.km-gift-card__price{gap:6px;margin-bottom:7px;font-size:12px}.km-gift-card__status{margin-bottom:10px;font-size:11px}.km-gift-detail{display:block}.km-gift-detail__media{min-height:auto;margin-bottom:16px;aspect-ratio:1/1}.km-gift-detail__image{width:58%;max-height:240px}.km-gift-detail__content h3{font-size:18px}.km-gift-detail__price{margin-bottom:20px;font-size:18px}.km-gift-detail__option{min-height:43px;padding:0 14px;font-size:13px}.km-gift-detail__description{margin-bottom:18px}.km-gift-detail__add{position:sticky;bottom:0;width:100%;min-height:50px}}',
      '@media(max-width:749px){.km-gift-dialog.is-detail{overflow:auto}.km-gift-dialog.is-detail .km-gift-dialog__panel{display:block;max-height:none}.km-gift-dialog.is-detail .km-gift-dialog__body{overflow:visible}.km-gift-detail{height:auto;min-height:0}.km-gift-detail__content{padding-top:4px;overflow:visible;scrollbar-gutter:auto}.km-gift-gallery__slide{}.km-gift-detail__image{width:auto;max-width:100%;max-height:100%}.km-gift-gallery__arrow{width:32px;height:32px;font-size:24px}.km-gift-gallery__dots{bottom:10px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function init() {
    var initialCartState = loadInitialCartState();

    initializeGiftEntryLocation();
    addStyles();
    gifts = loadGiftProducts();
    installGiftOptionClickListener();
    installPluginCartListener();

    getCart().then(function () {
      window.setTimeout(function () {
        lastGiftRestoreSignature = getRegularCartSignature(lastCart);
        initialCartSync = false;
        maybeAutoOpenGiftDialog(lastCart || initialCartState);
      }, 1200);
    });
    startContainerSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function () {
    checkoutHandoff = false;
    checkoutBypass = false;
    checkoutPending = false;
    window.clearTimeout(checkoutHandoffTimer);
    refreshEssentialCart();
  });
})();
